import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/reset-device-passwords', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (logninName, Options = {}) => {
  return httpClient
    .get(`/api/reset-device-passwords/${logninName}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/reset-device-passwords/${data.login_name}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  update
}
